import { track } from './track';

export function initPageLoadTime(): void {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') return;

  const obs = new PerformanceObserver((list) => {
    const entry = list.getEntries()[0] as PerformanceNavigationTiming | undefined;
    // loadEventEnd is 0 until the load event finishes; PerformanceObserver
    // fires after the entry is finalized, so by here it should be populated.
    if (!entry || entry.loadEventEnd <= 0) return;
    track('pagePerformance', {
      content: { pageLoadTime: Math.round(entry.loadEventEnd - entry.startTime) },
    });
    obs.disconnect();
  });

  // buffered: true replays the navigation entry even if we registered after `load` fired.
  try {
    obs.observe({ type: 'navigation', buffered: true });
  } catch {
    // Browser doesn't support navigation entries — silent no-op.
  }
}
